module.exports = __webpack_public_path__ + "static/27-c9380e8fa1f8b045f4b107b48d2a7df9.jpg";